import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// Chauffeur Redux States
import {
  GET_CHAUFFEURS,
  ADD_NEW_CHAUFFEUR,
  UPDATE_CHAUFFEUR,
} from "./actionType";

import {
  chauffeurApiResponseSuccess,
  chauffeurApiResponseError,

  addChauffeurFail,
  addChauffeurSuccess,
  updateChauffeurSuccess,
  updateChauffeurFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getChauffeurs as getChauffeursApi,
  addNewChauffeur,
  updateChauffeur,
} from "../../helpers/fakebackend_helper";

function* getChauffeurs() {
  try {
    const response = yield call(getChauffeursApi);
    yield put(chauffeurApiResponseSuccess(GET_CHAUFFEURS, response));
  } catch (error) {
    yield put(chauffeurApiResponseError(GET_CHAUFFEURS, error));
  }
}

function* onUpdateChauffeur({ payload: chauffeur}) {
  console.log(chauffeur);
  try {
    const response = yield call(updateChauffeur, chauffeur);
    console.log(response);
    yield put(updateChauffeurSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(updateChauffeurFail(error));
  }
}


function* onAddNewChauffeur({ payload: chauffeur }) {
  try {
    console.log(chauffeur);
    const response = yield call(addNewChauffeur, chauffeur);
    yield put(addChauffeurSuccess(response));
  } catch (error) {
    yield put(addChauffeurFail(error));
  }
}

export function* watchGetChauffeurs() {
  yield takeEvery(GET_CHAUFFEURS, getChauffeurs);
}


export function* watchUpdateChauffeur() {
  yield takeEvery(UPDATE_CHAUFFEUR, onUpdateChauffeur);
}

export function* watchAddNewChauffeur() {
  yield takeEvery(ADD_NEW_CHAUFFEUR, onAddNewChauffeur);
}

function* chauffeurSaga() {
  yield all([
    fork(watchGetChauffeurs),
    fork(watchUpdateChauffeur),
    fork(watchAddNewChauffeur),
  ]);
}

export default chauffeurSaga;
